import React from "react";
import Seo from "@/components/Seo";
import Breadcrumbs from "@/components/Breadcrumbs";
import { FAQ_ITEMS, breadcrumbLd, faqLd } from "@/lib/siteContent";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";

const crumbs = [{ label: "Home", to: "/" }, { label: "FAQ", to: "/faq" }];

export default function Faq() {
  return (
    <div className="ca-container py-12 max-w-3xl">
      <Seo title="ComplaintAdvisor FAQ | Complaints, Reviews, Vendors and Disputes"
        description="Find answers about filing complaints, responding to complaints, vendor reviews, privacy, moderation, dispute resolution, and account management."
        path="/faq" jsonld={[breadcrumbLd(crumbs), faqLd(FAQ_ITEMS)]} />
      <Breadcrumbs items={crumbs} />
      <h1 className="font-display text-3xl sm:text-4xl font-bold text-slate-900 mt-3">Frequently Asked Questions</h1>
      <Accordion type="single" collapsible className="mt-6 rounded-2xl border border-slate-200 bg-white px-4">
        {FAQ_ITEMS.map((f, i) => (
          <AccordionItem key={i} value={`q-${i}`} data-testid={`faq-item-${i}`}>
            <AccordionTrigger className="text-left text-slate-800">{f.q}</AccordionTrigger>
            <AccordionContent className="text-slate-600">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
